import { InviteRole } from '@shared/invite/enums';

export const InviteRolesMap = {
  [InviteRole.user]: 'User',
  [InviteRole.manager]: 'Manager',
  [InviteRole.admin]: 'Admin',
};
